<template>
    <v-btn @click="$emit('click')" icon class="rounded" color="orange" large><v-icon>mdi-refresh</v-icon></v-btn>
</template>
<script>
export default {
}
</script>
